import i18next from 'i18next';

export const formatSpecification = (product) => {
  // Handle specification unit, check if it's an object or a string
  const specificationUnit =
    typeof product.specification_unit === 'object'
      ? product.specification_unit?.name || ''
      : product.specification_unit || '';

  // If specification_value exists, show specification_value and specification_unit
  //remove 00
  const formattedValue =
    product.specification_value != null
      ? product.specification_value % 1 === 0
        ? parseInt(product.specification_value)
        : product.specification_value
      : '';

  const specification =
    formattedValue !== '' ? `${formattedValue} ${specificationUnit}` : '';
  // const specification = product.specification_value
  //   ? `${product.specification_value} ${specificationUnit}`
  //   : '';

  // If product_value exists, show it with product_unit
  const productUnit =
    typeof product.product_unit === 'object'
      ? product.product_unit?.name || ''
      : product.product_unit || '';
  const productValue = product.product_value
    ? `${product.product_value} ${productUnit}`
    : '';

  // If specification exists, append productValue after the slash. Otherwise, show only productValue.
  return specification ? `${specification} / ${productValue}` : productValue;
};

export const trimDecimalZero = (value) => {
  if (value == null) return '';
  return value % 1 === 0
    ? parseInt(value.toString()).toString()
    : value.toString();
};

export const formatDecimalTwoDigits = (value) => {
  if (value == null || value === '') return '';

  const num = parseFloat(value.toString());

  if (isNaN(num)) return '';

  return num.toFixed(2);
};

export const tUtil = (key, ns) => i18next.t(key, { ns: ns });

export const isValidImportFileName = (
  selectedFileName,
  expectedFileNames = []
) => {
  if (!selectedFileName || expectedFileNames.length === 0) return false;

  const stripExtension = (name) => name.replace(/\.[^/.]+$/, '').toLowerCase();
  const selectedBase = stripExtension(selectedFileName);

  return expectedFileNames.some((expected) =>
    selectedBase.includes(stripExtension(expected))
  );
};
